import { z } from "zod"
import { ProcessingHandlerType } from "./event-kind"
import { userChannelMessageSchema } from "./user-channel"

export const liveVideoDelayShutdownPayloadSchema = z.object({
    type: z.literal(ProcessingHandlerType.LiveVideoDelayShutdown),
    callback: z.string(),
})

export type LiveVideoDelayShutdownPayload = z.infer<typeof liveVideoDelayShutdownPayloadSchema>

export const importImagesPayloadSchema = z.object({
    type: z.literal(ProcessingHandlerType.ImportImages),
    requestId: z.string(),
    userId: z.string(),
    orgId: z.string(),
    projectId: z.string(),
    targetFlightId: z.string(),
    sourceFlightId: z.string(),
    sourceFlightType: z.enum(["ortho", "infrared"]),
    targetFlightType: z.enum(["ortho", "infrared"]),
})

export type ImportImagesPayload = z.infer<typeof importImagesPayloadSchema>

export const addLicenseUsagePayloadSchema = z.object({
    type: z.literal(ProcessingHandlerType.AddLicenseUsage),
    licenseId: z.string(),
    flightId: z.string(),
    projectId: z.string(),
    licenseOwnerId: z.string(),
    usageAmount: z.number(),
})

export type AddLicenseUsagePayload = z.infer<typeof addLicenseUsagePayloadSchema>

export const dispatchStitchPayloadSchema = z.object({
    type: z.literal(ProcessingHandlerType.DispatchStitch),
    layerId: z.string(),
    totalBytes: z.number(),
    stream: z.object({ key: z.string(), lockKey: z.string() }).optional(),
    dataPrefix: z.string().optional(),
    outputPrefix: z.string(),
    callbackRoute: z.string().optional(),
    renderMode: z.enum(["iterative", "oneShot", "oneShotWithPreview"]).optional(),
    detection: z.boolean().optional(),
    expectedCount: z.number().optional(),
})

export type DispatchStitchPayload = z.infer<typeof dispatchStitchPayloadSchema>

export const deliverUserChannelMessagePayloadSchema = z.object({
    type: z.literal(ProcessingHandlerType.DeliverUserChannelMessage),
    userId: z.string(),
    message: userChannelMessageSchema,
})

export type DeliverUserChannelMessagePayload = z.infer<
    typeof deliverUserChannelMessagePayloadSchema
>
